import { NamespaceLoggerAdapter } from '@fluidx/telemetry';
/**
 * A helper method that returns an implementation of NotificationService for containers backed by Sharepoint.
 * @param props The parameters required to instantiate the implementation
 */
export function getNotificationServiceForSharepoint(props) {
    return import('./SharepointNotificationService').then((m) => {
        return new m.SharepointNotificationService({
            ...props,
            logger: props.logger ? new NamespaceLoggerAdapter('NotificationService', props.logger) : undefined
        });
    });
}
//# sourceMappingURL=getNotificationServiceForSharepoint.js.map